// extracted by mini-css-extract-plugin
export default {"foto":"Foto_foto__CRi6c"};